import { memo } from 'react';
import { useSelector } from '@xstate/store/react';
import { useCanvasStores } from '../stores/CanvasContext';

function AlignmentGuidesOverlayInner() {
  const { dragStore, panZoomStore } = useCanvasStores();
  const alignmentGuides = useSelector(dragStore, s => s.context.alignmentGuides);
  if (alignmentGuides.length === 0) return null;
  const { panX, panY, zoom: z } = panZoomStore.getSnapshot().context;
  const vl = -panX / z;
  const vt = -panY / z;
  const vr = vl + window.innerWidth / z;
  const vb = vt + window.innerHeight / z;
  return (
    <>
      {alignmentGuides.map((guide, i) => (
        <div
          key={i}
          style={{
            position: 'absolute',
            left: guide.axis === 'vertical' ? guide.position : vl,
            top: guide.axis === 'horizontal' ? guide.position : vt,
            width: guide.axis === 'vertical' ? 0 : vr - vl,
            height: guide.axis === 'horizontal' ? 0 : vb - vt,
            borderLeft: guide.axis === 'vertical' ? '1px dashed #ec4899' : undefined,
            borderTop: guide.axis === 'horizontal' ? '1px dashed #ec4899' : undefined,
            opacity: 0.7,
            pointerEvents: 'none',
          }}
        />
      ))}
    </>
  );
}

export const AlignmentGuidesOverlay = memo(AlignmentGuidesOverlayInner);
